import LoaderButton from 'components/molecules/loader-button'
import cmsBlogPostSearchFormSchema from './cms-blog-post-search-form-schema'
import CmsBlogPostSelectSearchField from 'domains/cms-blog-post/molecules/select-search-field'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'

const propTypes = {
  handleSubmitForm : PropTypes.func.isRequired,
  setCustomerId    : PropTypes.func
}

/**
 * Form to add blog post to the list
 * @param {func} handleSubmitForm Handler for submitting the form
 */
const CmsBlogPostSearchForm = ({
  handleSubmitForm
}) => (
  <Formik
    enableReinitialize={ true }
    initialValues={{
      blog_post_id: ''
    }}
    validationSchema={ cmsBlogPostSearchFormSchema }
    onSubmit={ (values, formikBag) => handleSubmitForm(values, formikBag) }
  >
    {
      (formikBag) => (
        <Form>
          <CmsBlogPostSelectSearchField
            name='blog_post_id'
            label='Blog Post'
            required={ true }
          />

          <LoaderButton
            color='primary'
            type='submit'
            className='float-right'
            isLoading={ formikBag.isSubmitting }
            text='Add'
          />

        </Form>
      )
    }
  </Formik>
)

CmsBlogPostSearchForm.propTypes = propTypes

export default CmsBlogPostSearchForm